<div
  class="lum-c-cost-layer-changes-ag-cell-summary"
  *ngIf="change; else whenNoData"
>
  <dl class="dl-items-inline mb-0">
    <ng-container
      *ngIf="change.totalCostAfterChange - change.totalCostBeforeChange != 0"
    >
      <dt>Total Cost:</dt>
      <dd
        ><ng-container
          *ngTemplateOutlet="
            beforeAfterCurrency;
            context: {
              after: change.totalCostAfterChange,
              before: change.totalCostBeforeChange,
              diff: change.totalCostAfterChange - change.totalCostBeforeChange,
            }
          "
        ></ng-container
      ></dd>
    </ng-container>
    <dt>Cost of Remaining Qty:</dt>
    <dd
      ><ng-container
        *ngTemplateOutlet="
          beforeAfterCurrency;
          context: {
            after: change.remainingQuantityCostAfterChange,
            before: change.remainingQuantityCostBeforeChange,
            diff:
              change.remainingQuantityCostAfterChange -
              change.remainingQuantityCostBeforeChange,
          }
        "
      ></ng-container
    ></dd>
    <ng-container *ngIf="change.quantityChange && change.quantityChange !== '0'">
      <dt>Quantity:</dt>
      <dd>{{
        change.quantityChange == 0
          ? 'no change'
          : (change.quantityChange > 0 ? '+' : '') +
            (change.quantityChange | decimalPlaces)
      }}</dd>
    </ng-container>
    <ng-container
      *ngIf="change.costPerUnitChange && change.costPerUnitChange !== '0'"
    >
      <dt>Unit Cost:</dt>
      <dd>{{
        change.costPerUnitChange == 0
          ? 'no change'
          : (change.costPerUnitChange > 0 ? '+' : '') +
            (change.costPerUnitChange | currency)
      }}</dd>
    </ng-container>
  </dl>
  <!-- <pre class="lum-pre">{{ change | json }}</pre> -->
</div>
<ng-template #whenNoData>
  <ng-container *ngIf="didInit">ERROR</ng-container>
</ng-template>

<ng-template
  #beforeAfterCurrency
  let-before="before"
  let-after="after"
  let-diff="diff"
>
  {{ before | currency }} → {{ after | currency }} ({{
    diff === 0 ? 'no change' : (diff > 0 ? '+' : '') + (diff | currency)
  }})
</ng-template>
<ng-template
  #beforeAfterQuantity
  let-before="before"
  let-after="after"
  let-diff="diff"
>
  {{ before | decimalPlaces }} → {{ after | decimalPlaces }} ({{
    diff === 0 ? 'no change' : (diff > 0 ? '+' : '') + (diff | decimalPlaces)
  }})
</ng-template>
